module.exports = {
  Help: "Help",
  Register: "Register",
  Login: "Login",
  Inquiry: "Inquiry",
  Consultation: "Consultation",
  Viewing: "Viewing",
  Application: "Application",
  "Lease Signing": "Lease Signing",
  "Move In": "Move in",
  "Find your new home": "Find your new home",
  "Making your Japan home search easier.":
    "Making your Japan home search easier.",
  "Hot Properties": "Hot Properties",
  "Terms & Conditions": "Terms & Conditions",
  "Privacy Policy": "Privacy Policy",
  "Contact Us": "Contact Us",
  "For Owners": "For Owners",
  "About Us": "About Us",
  "Rental Procedure": "Rental Procedure",
  "JAPAN HOME FINDER - ALL RIGHTS RESERVED":
    "JAPAN HOME FINDER - ALL RIGHTS RESERVED",
  ADMIN: "ADMIN",
  "Account Settings": "Account Settings",
  "Saved Properties": "Saved Home",
  Consultation_content:
    "A real estate expert will conduct a needs analysis and consult with you over the phone to expand or narrow your search to find the right property for you.",
  Inquiry_content:
    "Find a property you are interested in and send us an inquiry. One of our bilingual real estate experts will contact you and kick off your home finding search.",
  Viewing_content:
    "A consultant will meet you and take you to walk through, inside & out, the property (or properties) you would like to see.",
  Application_content:
    "Once you decide on a property, we'll submit your application to the owner or management company and provide support toward its acceptance.",
  Lease_content:
    "Upon approval of the application, drafts of the lease & summary will be created for your review. We will confirm the terms, clauses & conditions and negotiate on your behalf.",
  MoveIn_content:
    "We guide you through the move-in inspection process and have the necessary preparations completed. The keys to your new home will then be handed to you. Welcome Home!",
  "Personalize Your Search": "Personalize Your Search",
  "WE assess your needs and send properties right for YOU, just for YOU":
    "WE assess your needs and send properties right for YOU, just for YOU",
  "Needs Assessment": "Needs Assessment",
  "Making It Easier": "Making It Easier",
  Logout: "Logout",
  "Welcome Back": "Welcome Back!",
  "Forgot password": "Forgot password",
  "Don't miss a thing": "Don’t miss a thing",
  "Save homes you loved and access them quickly":
    "Save homes you loved and access them quickly",
  "Be up to date": "Be up to date",
  "Receive special deals and updates on your favourite properties":
    "Receive special deals and updates on your favourite properties.",
  "Create an Account": "Create an Account",
  Name: "Name",
  Company: "Company",
  Phone: "Phone",
  Email: "Email",
  Password: "Password",
  "Confirm Password": "Confirm Password",
  "By registering you accept our Terms of Services and Privacy Policy":
    "By registering you accept our Terms of Services and Privacy Policy",
  Budget: "Budget",
  "Walk to Station": "Walk to Station",
  Bedrooms: "Bedrooms",
  "Property Features": "Property Features",
  "Search Results": "Search results",
  "Most Recent": "Most Recent",
  "Price (Low - High)": "Price (low-high)",
  "Price (High - Low)": "price(high-low)",
  "Size (Low - High)": "size(low-hight)",
  "Size (High - Low)": "size(high-low)",
  Apply: "apply",
  "Budget Range": "Budget Range",
  "Least Number of Bedrooms": "Least Number of Bedrooms",
  New: "New",
  Hot: "hot",
  Serviced: "serviced",
  "Pet Allowed": "Pet negotiable",
  "Search as I move the map": "Search as I move the map",
  "Back to all properties": "Back to all properties",
  Favorite: "Favorite",
  Share: "Share",
  "Inquire about this property": "Inquire about this property",
  "Property Overview": "Property Overview",
  "Property ID": "Property ID",
  "Property Type": "Property Type",
  Rooms: "Rooms",
  Floor: "Floor",
  Construction: "Construction",
  "Available Date": "Available Date",
  "Serviced Property": "Serviced Property",
  Size: "Size",
  "Year Built": "Year Built",
  Location: "Location",
  "Initial Costs": "Initial Costs",
  "Monthly Costs": "Monthly Costs",
  "Nearby Train Stations": "Nearby Train Stations",
  "Nearby Schools": "Nearby Schools",
  Notes: "notes",
  "Other properties in this building": "Other properties in this building",
  "Update account details": "Update account details",
  "Update Info": "Update Info",
  "Change Password": "Change Password",
  "Current password": "Current password",
  "New password": "New password",
  "Confirm new password": "Confirm new password",
  "Welcome back": "Welcome back",
  "My Account": "My Account",
  "Save homes": "Save homes",
  "Please Inquire": "Please Inquire",
  "Not Found": "Not Found",
  Title: "Title",
  Message: "Message",
  Submit: "Submit",
  "Find your nearest office": "Find your nearest office",
  "Parking Available": "Parking Available",
  Concierge: "Concierge",
  "Security Entrance": "Security Entrance",
  Balcony: "Balcony",
  "Private Yard": "Private Yard",
  "AC/Heating": "AC/Heating",
  Dishwasher: "Dishwasher",
  Dryer: "Dryer",
  Refrigerator: "Refrigerator",
  Print: "Print",
  "Need Personalized Search?": "Need Personalized Search?",
  "Per Month": "Per Month",
  "Available Now": "Available Now",
  Yes: "Yes",
  No: "No",
  Area: "Area",
  "Train Lines": "Train Lines",
  "Train Stations": "Train Stations",
  "No results found.": "No results found.",
  "Please Login To Continue": "Please Login To Continue",
  "Incorrect email address and / or password.":
    "Incorrect email address and / or password.",
  "There are no matching for your current search":
    "There are no matching for your current search",
  "Please broaden your search requirements":
    "Please broaden your search requirements"
};
